import { Box, Typography } from '@mui/material'
import { Section } from 'components'
import { List } from 'components/ui'
import { useMappedTranslation, usePageTitle } from 'hooks'

import ThirdPartyInfo from './assets/third-party-info.json'
import { ListItem } from '../../../../components/ui'

export default function ThirdPatry() {
  const t = useMappedTranslation()
  usePageTitle(t('iam.01.Common.Title.Consent.to.PDU.to.3rdParty.services'))

  const convertDescription = (fieldList: string) => {
    const fields = fieldList.split(',')

    const converted = fields
      .map((field) => {
        if (['familyName', 'givenName'].includes(field)) {
          return t('iam.01.Common.linking.to3rd.profile.Name')
        } else if ('userID' === field) {
          return t('iam.01.Common.linking.to3rd.profile.GUID')
        } else if ('loginID' === field) {
          return t('iam.01.Common.linking.to3rd.profile.ID')
        } else if ('birthDate' === field) {
          return t('iam.01.Common.linking.to3rd.profile.birthDate')
        }
        return null
      })
      .flatMap((f) => (f ? [f] : []))

    return Array.from(new Set<String>(converted)).join(', ')
  }

  return (
    <Box sx={{ width: '100%', height: '100%', padding: { xs: '24px', md: '0' } }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: { xs: '100%', md: '820px', lg: '1232px' }, mb: '48px' }}>
          <Section
            title={t('iam.01.Common.Title.Consent.to.PDU.to.3rdParty.services')}
            description={t('iam.01.Common.Txt.If.you.connect.your.SA.when.using.the.3rdParty.services.below')}
            articleSx={{
              padding: {
                xs: '20px 20px 8px',
                md: '30px 50px',
                lg: '48px 96px 48px'
              }
            }}
          >
            <Box>
              <Box>
                <Typography variant='subtitle2'>
                  {t('iam.01.Common.subTitle.3rdParty.services', { 0: ThirdPartyInfo.thirdPartyInfoDisplayList.length })}
                </Typography>
              </Box>
              <List
                sx={{
                  marginTop: { xs: '8px', md: '20px' },
                  padding: '14px 0px 0px',
                  paddingBottom: '14px'
                }}
              >
                {ThirdPartyInfo.thirdPartyInfoDisplayList.map((info, index) => (
                  <ListItem
                    sx={{
                      width: {
                        xs: '100%',
                        lg: '454px'
                      }
                    }}
                    key={info.appId}
                    index={index}
                    title={info.serviceName}
                    description={
                      <Typography
                        variant='listItemDescription'
                        sx={{ wordBreak: 'break-all', lineHeight: { xs: '18px', md: '20px' } }}
                      >
                        {`${t('iam.01.Common.Txt.Personal.information.provided.by.SA')} : ${convertDescription(
                          info.filedDisplayList
                        )}`}
                      </Typography>
                    }
                    iconItemSx={{
                      minWidth: {
                        xs: '52px',
                        md: '64px'
                      }
                    }}
                    dividerSx={{
                      marginLeft: { xs: '48px', md: '64px' }
                    }}
                    icon={
                      <Box
                        component='img'
                        alt=''
                        src={info.imageUrl}
                        sx={{
                          display: 'flex',
                          width: {
                            xs: '40px',
                            md: '48px'
                          },
                          height: {
                            xs: '40px',
                            md: '48px'
                          }
                        }}
                      />
                    }
                  ></ListItem>
                ))}
              </List>
            </Box>
          </Section>
        </Box>
      </Box>
    </Box>
  )
}
